import { Button } from 'components/buttons/button';
import gql from 'graphql-tag';
import Link from 'next/link';
import { useGetPifAndVoucherQuery } from 'lib/graphql-generated';
import { CardLoading } from 'components/card-loading';

gql`
  query GetPifAndVoucher {
    pif: unstructured_data_by_pk(title: "pif") {
      data
    }
    vouchers: unstructured_data_by_pk(title: "vouchers") {
      data
    }
  }
`;

interface Props {
  className?: string;
}

export const PifAndVoucherCards = ({ className }: Props) => {
  const { data, loading } = useGetPifAndVoucherQuery();

  return (
    <>
      {loading ? (
        <>
          <CardLoading />
          <CardLoading />
        </>
      ) : !!data ? (
        <>
          <article
            className={`group flex flex-col w-full max-w-2xs cursor-pointer ${className}`}>
            <Link href={`/shop/voucher`}>
              <a className='flex flex-col flex-1'>
                <img
                  src={data.vouchers.data.image}
                  alt={`Image for Lighthouse Vouchers`}
                  className='group-hover:-translate-y-1 transform ease-in transition-transform max-h-64 w-full'
                />
                <header className='pt-4 mt-auto'>
                  <h1 className='header text-xl group-hover:text-red-dark'>
                    Voucher
                  </h1>
                </header>
              </a>
            </Link>
            <section className='flex flex-row flex-wrap  border-gray-300  justify-between'>
              <hr className='bg-gray-300 w-full h-4 mb-2' />
              <Button
                buttonType='secondary'
                className='ml-auto'
                href={'/shop/voucher'}>
                View
              </Button>
            </section>
          </article>
          <article
            className={`group flex flex-col w-full max-w-2xs cursor-pointer ${className}`}>
            <Link href={`/shop/pif`}>
              <a className='flex flex-col flex-1'>
                <img
                  src={data.pif.data.image}
                  alt={`Image for Lighthouse Vouchers`}
                  className='group-hover:-translate-y-1 transform ease-in transition-transform max-h-64 w-full'
                />
                <header className='pt-4 mt-auto'>
                  <h1 className='header text-xl group-hover:text-red-dark'>
                    Pay It Forwards Voucher
                  </h1>
                </header>
              </a>
            </Link>
            <section className='flex flex-row flex-wrap  border-gray-300  justify-between'>
              <hr className='bg-gray-300 w-full h-4 mb-2' />
              <Button
                buttonType='secondary'
                className='ml-auto'
                href={'/shop/voucher'}>
                View
              </Button>
            </section>
          </article>{' '}
        </>
      ) : (
        <></>
      )}
    </>
  );
};
